import emma from '@/common/services/Emma'

const SiteResource = {
	getCurrentSite () {
		return emma.get('api/office/current', false)
	}
}

export default SiteResource



// WEBPACK FOOTER //
// ./src/common/resources/Site.js